module.exports = __webpack_public_path__ + "static/Jost-Light-1050fc045d1c00ed9292d633333172a9.woff2";